/* globals console, module, require */
/* jshint esversion: 6 */
/* jshint globalstrict: true */
'use strict';

const Backbone = require('backbone'),
    jQuery = require('jquery'),
    _ = require('lodash'),
    configuration = require('../utilities/configuration'),
    formProcessor = require('../utilities/formProcessor').processor,
    phoneify = require('../utilities/phoneify'),
    user = require('../models/user');

module.exports = Backbone.Model.extend({
    parse: function (results, options) {
        const result = _.isArray(results) ? results[0] : results;
        result.phone = phoneify(result.phone);
        return result;
    },
    sync: function (method, model, options) {
        const url = configuration.apiUrlBase + 'organization/',
            ajax = function (ajaxOptions) {
                jQuery.ajax(_.extend({
                    contentType: 'application/json',
                    dataType: 'json',
                    error: options.error,
                    headers: user.authorizationHeader('organization'),
                    success: options.success
                }, ajaxOptions));
            },
            methods = {
                create: function () {
                    ajax({
                        data: JSON.stringify(model.toJSON()),
                        method: 'POST',
                        url: url
                    });
                },
                delete: function () {
                    ajax({
                        method: 'DELETE',
                        url: url + model.id
                    });
                },
                update: function () {
                    ajax({
                        data: JSON.stringify(model.changed),
                        method: 'PUT',
                        url: url + model.id
                    });
                }
            };
        if (methods[method]) {
            methods[method](options);
        } else {
            Backbone.sync.apply(this, arguments);
        }
    },
    update: function (serializedForm, alwaysTrigger, callback) {
        const processedForm = formProcessor(serializedForm);
        this.set(processedForm);
        if (!_.isEmpty(this.changed)) {
            this.save(undefined, {
                success: function () {
                    if (callback) {
                        callback(null);
                    }
                },
                error: function (model, xhr, options) {
                    if (callback) {
                        callback('Unable to update program' + (xhr.responseJSON ? '\n(' + xhr.responseJSON.message + ')' : ''));
                    }
                }
            });
        } else if (alwaysTrigger) {
            this.trigger('change');
        }
    }
});
